import { render, staticRenderFns } from "./CommentFindingComponent.vue?vue&type=template&id=254b1406&"
import script from "./CommentFindingComponent.vue?vue&type=script&lang=js&"
export * from "./CommentFindingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports